import { FileType } from '@core/models/built/procedure-step-config.model';
import { Procedure, ProcedureStep, ProcedureStepLink } from '@core/models/procedures.model';
import { createAction, props } from '@ngrx/store';
import { ErrorDetail } from 'src/app/utils/errors.model';


const loadStepsAndLinks = createAction('[Procedure] Load steps and links by procedure id', props<{ id?: number }>());
const stepsAndLinksLoaded = createAction('[Procedure] Steps and links loaded', props<{
  procedure: Partial<Procedure>; steps: ProcedureStep[]; links: ProcedureStepLink[];
}>());

const saveProcedure = createAction('[Procedure] Save procedure', props<{ procedure: Partial<Procedure> }>());
const procedureSaved = createAction('[Procedure] Procedure saved', props<{ procedure: Procedure }>());
const deleteProcedure = createAction('[Procedure] Delete procedure', props<{ id: number }>());
const procedureDeleted = createAction('[Procedure] Procedure deleted');

const nextVersion = createAction('[Procedure] Create next version', props<{ id: number }>());

const validateDeploy = createAction('[Procedure] Validate deploy', props<{ id: number }>());
const deployValidated = createAction('[Procedure] Deploy validated', props<{ errors: ErrorDetail[] }>());
const deployProcedure = createAction('[Procedure] Deploy procedure', props<{ procedure: Procedure }>());
const procedureDeployed = createAction('[Procedure] Procedure deployed', props<{ procedure: Procedure }>());
const deployProcedureFailed = createAction('[Procedure] Deploy procedure failed', props<{ procedure: Procedure; errors: ErrorDetail[] }>());

const addStep = createAction('[Procedure] Add step', props<{ step: Partial<ProcedureStep> }>());
const stepAdded = createAction('[Procedure] Step added', props<{ step: ProcedureStep }>());
const updateStep = createAction('[Procedure] Update step', props<{ step: Partial<ProcedureStep> }>());
const stepUpdated = createAction('[Procedure] Step updated', props<{ step: ProcedureStep }>());
const stepSaveFailed = createAction('[Procedure] Step save failed', props<{ step: Partial<ProcedureStep>; errors: ErrorDetail[] }>());

const moveStep = createAction('[Procedure] Move graph node of step', props<{ step: ProcedureStep }>());
const stepMoved = createAction('[Procedure] Graph node of step moved', props<{ step: ProcedureStep }>());
const deleteStep = createAction('[Procedure] Delete step', props<{ id: number }>());
const stepDeleted = createAction('[Procedure] Step deleted', props<{ id: number }>());

const uploadStepFile = createAction('[Procedure] Upload step file', props<{ stepId: number; file: File; fileType: FileType; filename?: string; filenameToCreate?: string }>());
const stepFileUploaded = createAction('[Procedure] Step file uploaded', props<{ step: ProcedureStep }>());
const deleteStepFile = createAction('[Procedure] Delete step file', props<{ stepId: number; path: string }>());
const stepFileDeleted = createAction('[Procedure] Step file deleted', props<{ step: ProcedureStep }>());

const addLink = createAction('[Procedure] Add link', props<{ link: ProcedureStepLink }>());
const addLinkFailed = createAction('[Procedure] Add link failed', props<{ link: ProcedureStepLink; errors: ErrorDetail[] }>());
const linkAdded = createAction('[Procedure] Link added', props<{ link: ProcedureStepLink }>());
const deleteLink = createAction('[Procedure] Delete link', props<{ parentId: number; childId: number }>());
const linkDeleted = createAction('[Procedure] Link deleted', props<{ parentId: number; childId: number }>());


export const procedureActions = {
  loadStepsAndLinks,
  stepsAndLinksLoaded,

  saveProcedure,
  procedureSaved,
  deleteProcedure,
  procedureDeleted,
  nextVersion,

  validateDeploy,
  deployValidated,
  deployProcedure,
  procedureDeployed,
  deployProcedureFailed,

  addStep,
  stepAdded,
  updateStep,
  stepUpdated,
  stepSaveFailed,

  uploadStepFile,
  stepFileUploaded,
  deleteStepFile,
  stepFileDeleted,

  moveStep,
  stepMoved,

  deleteStep,
  stepDeleted,

  addLink,
  linkAdded,
  addLinkFailed,
  deleteLink,
  linkDeleted
};
